import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, Pipe ,Input} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { GetNewsForViewDto, MediaLibraryServiceProxy, MediaCenterServiceProxy, GetFAQCategoryForViewDto,FAQCategoryServiceProxy, GetMediaCenterForViewDto } from '@shared/service-proxies/service-proxies';
import { DateTime } from 'luxon';
import {  result } from 'lodash-es';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import {DataViewModule} from 'primeng/dataview';
import { LazyLoadEvent } from 'primeng/api';
@Component({
  selector: 'seek-landing-light',
  templateUrl: './landing-light.component.html',
  styleUrls: ['./landing-light.component.scss'],
  animations: [appModuleAnimation()]
})
export class LandingLightComponent extends AppComponentBase implements OnInit {
    newsList: Array<GetMediaCenterForViewDto>;
    faqcategories:Array<GetFAQCategoryForViewDto>;
  responsiveOptions;

  cities = [
    {
      src: "/assets/common/images/carousel-01.png",
      alt: "photo 1"
    },
    {
      src: "/assets/common/images/carousel-02.png",
      alt: "photo 2"
    },
    {
      src: "/assets/common/images/carousel-01.png",
      alt: "photo 3"
    },
    {
      src: "/assets/common/images/carousel-02.png",
      alt: "photo 4"
    },
    {
      src: "/assets/common/images/carousel-01.png",
      alt: "photo 5"
    },
    {
      src: "/assets/common/images/carousel-02.png",
      alt: "photo 6"
    },
    {
      src: "/assets/common/images/carousel-01.png",
      alt: "photo 7"
    }
  ];

  constructor(injector: Injector,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _mediaCenterServiceProxy: MediaCenterServiceProxy,
    private _faqCategoryServiceProxy:FAQCategoryServiceProxy) {
            super(injector);
    this.responsiveOptions = [
      {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 3
      },
      {
          breakpoint: '768px',
          numVisible: 2,
          numScroll: 2
      },
      {
          breakpoint: '560px',
          numVisible: 1,
          numScroll: 1
      }
  ];
  }

  ngOnInit() {
    this.loadImportantNews();
    this.loadFaqtopThreeCategories();
  }
  loadImportantNews(event?: LazyLoadEvent)
  {
    this._mediaCenterServiceProxy.getAllPublished('', 1,'PublishStateDate desc',0,3).pipe(finalize(() => {

    })).subscribe((result) => {
        if(result.totalCount>0){

          this.newsList=result.items;
        }else{
          this.newsList=[];
        }


     

   });
  }
  loadFaqtopThreeCategories()
  {
    this._faqCategoryServiceProxy.getAllLookUp("").subscribe((faqcategoryResult)=>{
        this.faqcategories=faqcategoryResult.slice(0,3);
    });
  }

}
